export const SAVED_SEARCH_LOAD = '@@saved_search/SAVED_SEARCH_LOAD';
export const DELETE_SEARCH_LOAD = '@@saved_search/DELETE_SEARCH_LOAD';
export const UNSUBSCRIBE_SAVED_SEARCH = '@@saved_search/UNSUBSCRIBE_SAVED_SEARCH';
export const SUBSCRIBE_SAVED_SEARCH = '@@saved_search/SUBSCRIBE_SAVED_SEARCH';
export const LOAD_COUNT_ANNOUNCEMENT_BY_SAVED_SEARCH = '@@saved_search/LOAD_COUNT_ANNOUNCEMENT_BY_SAVED_SEARCH';



// WEBPACK FOOTER //
// ./src/app/SavedSearch/actionTypes.js